import React from "react";
import FormLabel from "./FormLabel";
import { IoIosInformationCircleOutline } from "react-icons/io";

const SelectBox = ({
  data,
  dependentOn,
  disabled,
  idField = "idField",
  error,
  label,
  multiple,
  name,
  id,
  value = "",
  valueField = "valueField",
  onChange,
  onClick,
  onBlur,
  fullwidth = false,
  placeholder = "Select",
  className = "",
}) => {
  const handleChange = (e) => {
    onChange(e, name);
  };

  return (
    <div className={`${!dependentOn ? "hidden" : ""} w-full max-w-full min-w-0`}>
      <FormLabel
        text={label}
        color={error ? "red" : "black"}
        error={error}
        errorText={`${label} must be selected.`}
        customClass="w-full lg:w-1/2 max-w-full min-w-0"
      >
        <div className={`flex items-center border rounded-lg w-full max-w-full min-w-0  ${error ? "border-red-400 focus-within:border-red-400" : "focus-within:border-blue-400"}`}>
          <select
            id={!id ? name : id}
            key={`selectbox-${label}`}
            name={name}
            value={value}
            onClick={onClick}
            onChange={(e) => handleChange(parseInt(e.target.value))}
            disabled={disabled}
            className={`min-w-0 font-normal px-3 focus:border-blue-500 py-2.5 rounded-lg outline-none text-black text-sm sm:text-base ${className} cursor-pointer`}
          >
            <option key={0} value={""}>
              {data ? "Select" : "Loading...."}
            </option>
            {data &&
              data.map((dataItem) => (
                <option key={dataItem[idField]} value={dataItem[idField]}>
                  {dataItem[valueField]}
                </option>
              ))}
          </select>
          {error && <IoIosInformationCircleOutline className="w-5 h-5 mr-2" /> }
        </div>
      </FormLabel>
    </div>
  );
};

export default React.memo(SelectBox);
